import type { Lut } from '../types/lut';
import type { GetLutDto, GetLutsDto } from '../dto/lutDtos';
import type { BasicFetch } from '../types/basicFetch';
import { readWholeStream } from './readableStream';
import { parseLutCube } from './lutParser';

export function createDefaultGetLuts(
  getLuts: (() => Promise<GetLutsDto>),
  fetch: BasicFetch,
): (() => Promise<Lut[]>) {
  const getLut = async (dto: GetLutDto): Promise<Lut> => {
    const response = await fetch(dto.url, { });
    if (!response.ok) {
      throw new Error('Failed to fetch LUT');
    }
    if (response.body === null) {
      throw new Error('LUT response body is empty');
    }
    const bytes = await readWholeStream(response.body);

    const parsedLut = parseLutCube(bytes);

    const lut : Lut = {
      id: dto.id,
      title: dto.title,
      input: dto.input,
      output: dto.output,
      size: parsedLut.size,
      format: parsedLut.format,
      buffer: parsedLut.content,
      inRange: parsedLut.inRange,
      outRange: parsedLut.outRange,
    };

    return lut;
  };

  return async (): Promise<Lut[]> => {
    const dto = await getLuts();

    const lutPromises = dto.luts.map((lut) => getLut(lut));

    return await Promise.all(lutPromises);
  };
}

